import { render, staticRenderFns } from "./AbbvieHeader.vue?vue&type=template&id=98353cf6&scoped=true"
import script from "./AbbvieHeader.vue?vue&type=script&lang=js"
export * from "./AbbvieHeader.vue?vue&type=script&lang=js"
import style0 from "./AbbvieHeader.vue?vue&type=style&index=0&id=98353cf6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98353cf6",
  null
  
)

export default component.exports